import request from '@/utils/request'


// 查询手机区号列表
export function listMobileCode(query) {
  return request({
    url: '/mobileCode/mobileCode/list',
    method: 'get',
    params: query
  })
}

// 查询手机区号分页
export function pageMobileCode(query) {
  return request({
    url: '/mobileCode/mobileCode/page',
    method: 'get',
    params: query
  })
}

// 查询手机区号详细
export function getMobileCode(data) {
  return request({
    url: '/mobileCode/mobileCode/detail',
    method: 'get',
    params: data
  })
}

// 新增手机区号
export function addMobileCode(data) {
  return request({
    url: '/mobileCode/mobileCode/add',
    method: 'post',
    data: data
  })
}

// 修改手机区号
export function updateMobileCode(data) {
  return request({
    url: '/mobileCode/mobileCode/edit',
    method: 'post',
    data: data
  })
}
export function changeIsOpen(data) {
  return request({
    url: '/mobileCode/mobileCode/edit',
    method: 'post',
    data: data
  })
}
// 删除手机区号
export function delMobileCode(data) {
  return request({
    url: '/mobileCode/mobileCode/delete',
    method: 'post',
    data: data
  })
}
